// TermsAndConditionsPage.js
import React from 'react';
import './SafetyGuidelines.css'

const SafetyGuidelines = () => {
    return (
        <section className='terms-container'>
            <div className='terms-content'>
                <h1>Welcome to Vihana Matrimony App!</h1>
                <p>Your journey to finding the perfect life partner starts here. To ensure a safe and enriching experience, we recommend following these guidelines:</p>

                <h2>Profile Creation</h2>
                <ul>
                    <li><strong>Be Honest</strong> – Provide accurate details about yourself, your interests, and what you seek in a partner.</li>
                    <li><strong>Upload Quality Photos</strong> – Use clear, recent photos that reflect your personality. Include a mix of headshots and full-body images.</li>
                    <li><strong>Create a Detailed Bio</strong> – Highlight your values, hobbies, and goals in your bio to attract like-minded matches.</li>
                    <li><strong>Verify Your Profile</strong> – Use our verification feature to build trust and credibility.</li>
                    <li><strong>Control Profile Privacy</strong> – Utilize app settings to decide who can view your profile and keep your contact information private.</li>
                </ul>

                <h2>Photo Safety</h2>
                <ul>
                    <li><strong>Avoid Identifiable Locations</strong> – Refrain from using photos that reveal your home or workplace.</li>
                    <li><strong>Leverage Privacy Features</strong> – Adjust your photo visibility settings for better control over who views your pictures.</li>
                </ul>

                <h2>Searching and Matching</h2>
                <ul>
                    <li><strong>Set Preferences</strong> – Define criteria like age, location, and education to refine your matches.</li>
                    <li><strong>Keep an Open Mind</strong> – Stay flexible and consider profiles that might not meet all your preferences.</li>
                    <li><strong>Use Filters Effectively</strong> – Narrow your search using filters but remain open to unexpected matches.</li>
                </ul>

                <h2>Communication</h2>
                <ul>
                    <li><strong>Start the Conversation</strong> – Send polite and thoughtful messages to initiate interactions.</li>
                    <li><strong>Be Respectful</strong> – Maintain politeness in conversations and avoid personal questions early on.</li>
                    <li><strong>Take Your Time</strong> – Build trust gradually before sharing personal details.</li>
                    <li><strong>Video Chat Before Meeting</strong> – Use our video chat feature to verify identities and establish comfort before meeting in person.</li>
                </ul>

                <h2>Safety and Privacy</h2>
                <ul>
                    <li><strong>Protect Personal Details</strong> – Avoid sharing personal information like your home address, financial details, or personal photos until you feel completely comfortable.</li>
                    <li><strong>Use In-App Messaging</strong> – Communicate through the app until trust is established.</li>
                    <li><strong>Meet in Public</strong> – For initial meetings, choose public locations and inform a friend or family member about your plans.</li>
                    <li><strong>Trust Your Instincts</strong> – Block and report users who make you uncomfortable or exhibit suspicious behavior.</li>
                    <li><strong>Recognize Red Flags</strong> – Be cautious of individuals who pressure you for information, and avoid video chatting or meetings.</li>
                    <li><strong>Safeguard Social Media</strong> – Avoid linking your matrimony profile to other social media accounts and be wary of friend requests from matches.</li>
                    <li><strong>Stay Alert to Scams</strong> – Verify the identity of long-distance matches through video chats.</li>
                </ul>

                <h2>Managing Expectations</h2>
                <ul>
                    <li><strong>Be Patient</strong> – Finding the right partner takes time; stay persistent and positive.</li>
                    <li><strong>Stay True to Yourself</strong> – Authenticity is key to building meaningful connections.</li>
                </ul>

                <h2>Financial Safety</h2>
                <ul>
                    <li><strong>Never Send Money</strong> – Be cautious of any requests for financial help.</li>
                    <li><strong>Avoid Sharing Financial Information</strong> – Keep sensitive information like bank details and passwords private.</li>
                </ul>

                <h2>Building Connections</h2>
                <ul>
                    <li><strong>Explore Shared Interests</strong> – Bond over mutual hobbies and values.</li>
                    <li><strong>Plan Fun Activities</strong> – Engage in activities together to deepen your understanding of one another.</li>
                    <li><strong>Communicate Openly</strong> – Honest conversations are the foundation of strong relationships.</li>
                </ul>

                <h2>Additional Features</h2>
                <ul>
                    <li><strong>Background Verification</strong> – Use our verification tools and consider independent checks for added confidence.</li>
                    <li><strong>Report Misconduct</strong> – Use in-app reporting to notify us of inappropriate behavior and ensure community safety.</li>
                    <li><strong>Secure Your Account</strong> – Choose a strong password and enable two-factor authentication to protect your profile.</li>
                </ul>

                <p>By adhering to these guidelines, you can maximize your experience and create meaningful connections through our app. Best wishes for your journey toward finding your life partner!</p>
            </div>
        </section>
    );
};

export default SafetyGuidelines;
